export enum TABS {
  MOBILE = 'mobile',
  INTERNET = 'internet'
}

export const TABS_LABEL = {
  [TABS.MOBILE]: 'Мобильная связь',
  [TABS.INTERNET]: 'Домашний интернет',
};